export const config = {
  id: 'backend',
  icon: 'Server',
  color: 'green',
  title: 'Backend Developer',
  description: 'Server-side development, APIs, databases, and system architecture',
  department: 'Engineering',
  experienceLevels: ['junior', 'mid', 'senior'],
  operatingSystems: ['macos', 'windows', 'linux'],
  estimatedOnboardingDays: {
    junior: 7,
    mid: 5,
    senior: 3
  }
};
